import Hero from "@/components/Hero";
import Accreditations from "@/components/Accreditations";
import About from "@/components/About";
import Stats from "@/components/Stats";
import Brands from "@/components/Brands";
import Purpose from "@/components/Purpose";
import WhyChooseUs from "@/components/WhyChooseUs";
import Testimonials from "@/components/Testimonials";
import CTA from "@/components/CTA";
import Seo from "@/components/Seo";

const HomePage = () => (
  <main>
    <Seo
      title="Specialized Travel Brands for Every Journey"
      path="/"
      description="HI Tours Group is a family of specialized travel brands, Hi DMC, Hi Tours, and Hi Offsite, delivering destination management, leisure travel, and corporate offsites with 30+ years of expertise."
    />
    <Hero />
    <Accreditations />
    <About />
    <Stats />
    <Brands />
    <Purpose />
    <WhyChooseUs />
    <Testimonials />
    <CTA />
  </main>
);

export default HomePage;
